export const isWorkflowImportDialogOpen = state =>
  state.workflowImport.workflowImportDialogIsOpen;
